export const projectStatuses = {
  deleted: 'Deleted',
  finished: 'Finished',
  active: 'Active',
};
